module.exports = __webpack_public_path__ + "img/404.d35cd596.png";